import type { NavItem } from '@/entities/session';

export interface NavGroup {
  /** Ключ группы: `group_key` из ответа или подпись группы. */
  key: string;
  group: string;
  items: NavItem[];
}

/**
 * Меню строится только из `nav` GET /admin/me (ТЗ 4.2.2.1): порядок групп и пунктов — как в ответе.
 * Группа существует, только если в ней есть пункты — пустые группы не показываются.
 */
export function groupNav(nav: readonly NavItem[]): NavGroup[] {
  const groups: NavGroup[] = [];
  for (const item of nav) {
    const key = item.group_key ?? item.group;
    const existing = groups.find((group) => group.key === key);
    if (existing) {
      existing.items.push(item);
    } else {
      groups.push({ key, group: item.group, items: [item] });
    }
  }
  return groups;
}

export function findNavItem(nav: readonly NavItem[], key: string | undefined): NavItem | undefined {
  return key === undefined ? undefined : nav.find((item) => item.key === key);
}
